import React from 'react';

import {Navigate} from 'react-router';

import {LinearProgress} from 'views/components';
import {Helmet, useParams} from 'views/module';

import LoomCaregiverViewScene from 'views/scenes/caregiver/loom/detail/LoomCaregiverView';

import FLAGS, {useFlag} from 'utils/feature_flags/flags';

const LoomCaregiverView = (props) => {
  const caregiverReadFlag = useFlag(FLAGS.CAREGIVER_READS_FROM_LOOM);
  const params = useParams();

  if (caregiverReadFlag.isLoading) {
    return <LinearProgress color="secondary" />;
  }

  if (!caregiverReadFlag.isEnabled) {
    return <Navigate to="/caregiver" replace />;
  }

  return (
    <>
      <Helmet>
        <title>Quilt: Loom Caregiver Details</title>
      </Helmet>
      <LoomCaregiverViewScene
        caregiverRn={params.caregiverRn}
      />
    </>
  );
};

export default LoomCaregiverView;
